import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { Stack, IconButton } from '@mui/material';
import Iconify from '../iconify';
import { GloginComponent } from '../glogin';
import AccountPopover from '../../layouts/admin/header/AccountPopover';
import { useUser } from '../../hooks/UserContext';

HeaderNav.propTypes = {
  settingsPath: PropTypes.string.isRequired,
  onOpenChat: PropTypes.func,
};

export default function HeaderNav({ settingsPath, onOpenChat }) {
  const { user } = useUser();

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      {onOpenChat && (
        <IconButton onClick={onOpenChat} sx={{ color: 'text.secondary' }} title="AI Assistant">
          <Iconify icon="eva:message-circle-fill" />
        </IconButton>
      )}
      <IconButton component={RouterLink} to={settingsPath} sx={{ color: 'text.secondary' }}>
        <Iconify icon="eva:settings-2-outline" />
      </IconButton>

      {user != null ? <AccountPopover /> : <GloginComponent />}
    </Stack>
  );
}
